const IRBState = {
  irbApprovalDetails: {},
  piDetails: []
};

export default IRBState;
